import { clone, equals } from 'ramda';

import { type IJsonQueryRegionalDistrict } from '../api-models/common/json_query';

import { setGeo } from './helpers';
import { type NonEmptyArray, type TJsonQuery } from './types';

export function setRegionalDistricts(
  jsonQuery: TJsonQuery,
): (...geoDistricts: NonEmptyArray<IJsonQueryRegionalDistrict>) => TJsonQuery {
  return (...geoDistricts) => {
    const geo = (jsonQuery.geo && clone(jsonQuery.geo.value)) || [];

    const nextGeo = geo.filter(g => g.type !== 'regional_district_id' || geoDistricts.some(d => d.id === g.id));
    const addedGeoDistricts = geoDistricts.filter(d => !geo.some(g => equals(d, g)));

    return setGeo()(jsonQuery)([...nextGeo, ...addedGeoDistricts]);
  };
}
